import { useEffect, useState } from "react";
import { Button, Switch, Table } from "antd";
import {
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  LeftOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Loader } from "../common/Loader";
import { toast, ToastContainer } from "react-toastify";
import {
  cloneProfile,
  deleteProfile,
  getProfileListing,
  makeProfileDefault,
} from "../apiservice/ApiService";
import { DeleteModal } from "./components/DeleteModal";
import { NewSearchBox } from "../common/New SearchBox";

export const Profile = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [cloneDataSource, setCloneDataSource] = useState([]);
  const [deleteModalOpen, setDeleteMOdalOpen] = useState({
    flag: false,
    id: "",
  });

  const settingData = JSON.parse(localStorage.getItem("settings")) || {
    image: "https://onboardify.tasc360.com/uploads/y22.png",
    site_bg: "#ffffff",
    button_bg: "#497ed8",
    banner_bg: "#497ed8",
    banner_content:
      "Hire an attitude, not just experience and qualification. Greg Savage.",
    header_bg: "#f7f7f7",
    head_title_color: "#497ed8",
  };

  const handleNavigateToCreateProfile = () => {
    navigate("/admin/createprofile");
  };

  const onChangeSwitch = async (e, id) => {
    if (!e) {
      toast.error("One Profile must be default.");
      return;
    }
    const tempDataSource = [...dataSource];
    let payload = {
      profile_id: id,
      value: e,
    };

    setLoading(true);
    try {
      const response = await makeProfileDefault(JSON.stringify(payload));
      if (response.success) {
        tempDataSource.forEach((item) => {
          item.default = item.id === id ? true : false;
        });
        toast.success(response.message);
        setDataSource(tempDataSource);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteProfile = async () => {
    setLoading(true);
    try {
      const response = await deleteProfile(deleteModalOpen.id);
      if (response.success) {
        toast.success(response.message);
        setDeleteMOdalOpen({ flag: false, id: "" });
        await getListOfAllProfiles();
      } else {
        toast.error(response.message);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteModal = (id) => {
    setDeleteMOdalOpen({ flag: true, id: id });
  };

  const handleEditProfile = (item) => {
    const dataToPass = {
      profileId: item.id,
      profileTitle: item.title,
      users: item.users,
    };

    navigate("/admin/editprofile", {
      state: dataToPass,
    });
  };

  const handleCloneProfile = async (id) => {
    try {
      const response = await cloneProfile(id);
      if (response.success) {
        toast.success(response.message);
        getListOfAllProfiles();
      } else {
        toast.error(response.message);
      }
    } catch (err) {
    } finally {
    }
  };

  const openReportPage = (item) => {
    navigate("/admin/reportSettings", { state: item.id });
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      width: 60,
    },
    {
      title: "Name",
      dataIndex: "title",
      width: 200,
    },
    {
      title: "User List",
      dataIndex: "users",
    },
    {
      title: "Governify Report Settings",
      dataIndex: "report",
      render: (_, record) => (
        <Button onClick={() => openReportPage(record)}> Open</Button>
      ),
    },
    {
      title: "Default Profile",
      dataIndex: "make_default",
      render: (_, record) => (
        <>
          <Switch
            checked={record.default == 1}
            onChange={(e) => onChangeSwitch(e, record.id)}
          />
        </>
      ),
      width: 150,
    },
    {
      title: "Action",
      dataIndex: "",
      key: "x",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "4px" }}>
          <Button
            className="governify-delete-icon"
            type="plain"
            icon={<EditOutlined />}
            onClick={() => handleEditProfile(record)}
          ></Button>

          <Button
            className="governify-delete-icon"
            type="plain"
            icon={<DeleteOutlined />}
            onClick={() => handleDeleteModal(record.id)}
          ></Button>
          <Button
            className="governify-delete-icon"
            type="plain"
            icon={<CopyOutlined />}
            onClick={() => handleCloneProfile(record.id)}
          ></Button>
        </div>
      ),
      width: 100,
      fixed: "right",
    },
  ];

  const handleBackNavigation = () => {
    navigate("/admin");
  };

  const getListOfAllProfiles = async () => {
    let tempListing = [];
    setLoading(true);
    try {
      const response = await getProfileListing();

      if (response.success) {
        response.data.response.forEach((item) => {
          tempListing.push({
            id: item.id,
            title: item.title,
            users: item.users
              .split(",")
              .map((user) => user.trim())
              .join(" , "),
            default: item.make_default === 0 ? false : true,
            governify_board_id: item.governify_board_id,
            governify_table_settings: item.governify_table_settings,
            governify_filter_key: item.governify_filter_key,
          });
        });
        setDataSource(tempListing);
        setCloneDataSource(tempListing);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getListOfAllProfiles();
  }, []);

  useEffect(() => {
    const cloneData = [...cloneDataSource];
    const tempSearchData = [];
    if (searchData.length > 0) {
      cloneData.forEach((item) => {
        if (
          item.title.toLowerCase().includes(searchData.toLowerCase())
        ) {
          tempSearchData.push(item);
        }
      });
      setDataSource(tempSearchData);
    } else {
      setDataSource(cloneData);
    }
  }, [searchData]);

  return (
    <div className="pt-84">
      {loading && <Loader />}

      <div>
        <div
          style={{
            marginTop: "10px",
            marginBottom: "10px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            icon={
              <LeftOutlined
                style={{
                  color: settingData.button_bg,
                  borderColor: settingData.button_bg,
                }}
              />
            }
            onClick={handleBackNavigation}
            style={{ border: `1px solid ${settingData.button_bg}` }}
          ></Button>
          <Button
            icon={
              <PlusOutlined
                style={{
                  color: settingData.button_bg,
                  borderColor: settingData.button_bg,
                }}
              />
            }
            onClick={handleNavigateToCreateProfile}
            style={{
              border: `1px solid ${settingData.button_bg}`,
              color: settingData.button_bg,
            }}
          >
            Create Profile
          </Button>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <NewSearchBox
            placeHolder={"Start Typing To Search By Profile"}
            setSearchData={setSearchData}
            flag={false}
          />
        </div>

        <Table
          columns={columns}
          dataSource={dataSource}
          showSorterTooltip={{
            target: "sorter-icon",
          }}
          scroll={{ x: 768 }}
          pagination={{
            showTotal: (total) => `Total ${total} items`,
            defaultPageSize: 20,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [20, 25, 30, 35],
            defaultCurrent: 1,
          }}
        />
      </div>

      <ToastContainer position="bottom-right" />

      {deleteModalOpen.flag && (
        <DeleteModal
          open={deleteModalOpen.flag}
          handleCancel={() => {
            setDeleteMOdalOpen({ flag: false, id: "" });
          }}
          handleDelete={handleDeleteProfile}
          message={"Are you sure you want to delete this Profile?"}
        />
      )}
    </div>
  );
};
